<template>
	<div class="dashboard_container admin_dashboard" aria-label="Admin Dashboard Page Content">

	    <div class="row dashboard-content-section">

            <b-col class="col-xl-8 col-lg-8 col-md-12 col-sm-12">
                <div class="dashboard-row">
                    <div class="card ace_sec sec_report" aria-label="Reports Section">
                        <div class="card-header">
                          <span class="icon float-left icon-course text-center mr-2"></span>
                          <span class="label ace_sec_hd" role="heading" aria-level="1">Reports</span>
                          <b-link class="hd_lnk" @click="navigateToReports()" aria-label="navigate to reports page">more</b-link>
                        </div>
                        <div class="card-body">
                          <template v-for="c in dashboardReports">
                            <div class="row report_sec_block" @click="navigateToReports()">
                              <div class="col-12 hd ace_sec_hd" :aria-label="c.title">
                  							<span>{{c.title}}</span>
                  						</div>
                            	<div class="col-12">
                                <report :selectedReport="c" :type="c.visualizationType" :timeperiod="'60'"></report>
                              </div>
                            </div>
                          </template>
                          <template v-if="dashboardReports.length == 0">
                            <div class="row">
                              <div class="col-12">
                                <dummy-graph ref="DummyGraph"></dummy-graph>
                              </div>
                            </div>
                          </template>
                        </div>
                    </div>
                </div>
            </b-col>

            <b-col class="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                <b-row class="dashboard-row">
                    <b-col cols="12">
                        <div class="card ace_sec sec_notifications" aria-label="Notifications Section">
                            <div class="card-header">
                                <span class="icon float-left icon-bell text-center mr-2"></span>
                                <span class="label ace_sec_hd" role="heading" aria-level="1">Urgent Notifications</span>
                            </div>
                            <div class="card-body">
                                <div class="card-content v_scroll">

                                    <div class="recommendations">

                                        <div class="coming_soon ace_sec_txt">Coming Soon</div>

                                        <!--
                                        <div class="row">
                                            <div class="profile_pic">
                                                <span class="icon icon-admin"></span>
                                            </div>
                                            <div class="details">
                                                <div class="tp_row">
                                                    <div class="title">Administrator</div>
                                                    <div class="time">7:23 PM</div>
                                                </div>
                                                <div class="btm_row">
                                                    Internship at Qualcom
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="profile_pic">
                                                <span class="icon icon-user"></span>
                                            </div>
                                            <div class="details">
                                                <div class="tp_row">
                                                    <div class="title">Prof. Whitman</div>
                                                    <div class="time">7:43 PM</div>
                                                </div>
                                                <div class="btm_row">
                                                    Internship at Illumina. There is only one space left.
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="profile_pic">
                                                <span class="icon icon-user"></span>
                                            </div>
                                            <div class="details">
                                                <div class="tp_row">
                                                    <div class="title">Prof. Kandinsky</div>
                                                    <div class="time">6:18 PM</div>
                                                </div>
                                                <div class="btm_row">
                                                    Veterna’s Center talk
                                                </div>
                                            </div>
                                        </div>
                                        -->
                                        <!-- row end -->

                                    </div> <!-- recommendations end -->

                                </div> <!-- card-content end -->
                            </div> <!-- card-body end -->
                        </div> <!-- card end -->
                    </b-col>
                </b-row> <!-- dashboard-row end -->

              <b-row class="dashboard-row btm-sec quick-links">
                    <b-col cols="12">
                        <div class="card ace_sec quick_links_sec" aria-label="Quick Links Section">
                            <div class="card-header">
                                <span class="icon float-left icon-link text-center mr-2"></span>
                                <span class="label ace_sec_hd" role="heading" aria-level="1">Quick Links</span>
                            </div>
                            <div class="card-body quick-links-section">
                                <div class="card-content v_scroll">
									<div class="quick_link">
										<ul role="list">
											<li v-for="quickLink in quickLinks">
	                                        	<a :href="quickLink.url" target="_blank" :aria-label="'Link to ' + quickLink.title" tabindex="0" role="link">{{quickLink.title}}</a>
	                                        </li>
	                                    </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-col>

	    </div>

	</div>
</template>

<script>
  import '../../../assets/module/css/dashboard/dashboard.min.css'
  import DummyGraph from './dummyGraph'
  import Report from '../../institution/components/Report'
  import { mapState, mapActions } from 'vuex'

  var staticQuickLinks = function () {
    var quickLinks = [
    ]
    return quickLinks
  }

  export default {
    name: 'admin-dashboard',
    components: {
      DummyGraph,
      Report
    },
    props: [],
    data: () => {
      return {
        report: '',
        page: 0,
        courses: [],
        lastPage: false,
        quickLinks: [],
        userReports: []
      }
    },

    ready: function () {
      window.addEventListener('resize', this.populateOwnedCourses())
    },

    mounted () {
      this.loadAdminDashboard()
    },

    methods: {
      ...mapActions([
        'loadQuickLinks',
        'loadOwnedCourses',
        'loadAdminReport',
        'loadUserReports'
      ]),

      async loadAdminDashboard () {
        this.navigateToCustomDashbaord()
        this.loadQuickLinks('QUICKLINK').then(res => {
          const quickLinks = (this.links.length > 0) ? this.links : staticQuickLinks()
          $.each(quickLinks, (index, quickLink) => {
            this.quickLinks.push(quickLink)
          })
        })
        this.populateOwnedCourses()
        this.userReports = await this.loadUserReports()
        window.addEventListener('resize', this.handleWindowResize)
      },
      navigateToCustomDashbaord () {
        if(this.userObj.customAdmin) {
            let customDashboardUrl = '/institution/'+this.userObj.institutionId+'/setting/about'
            if(this.userObj.customPermission && this.userObj.customPermission.supervisorRole){
                customDashboardUrl = '/dashboard/supervisor'
            }
            return this.$router.push(customDashboardUrl)
        }
      },

      navigateToReports () {
        $('.icon-home').removeClass('active')
        return this.$router.push({ name: 'institutionReports', params: { uuid: this.institution.uuid } })
      },

      handleWindowResize (event) {
        let routeName = this.$router.currentRoute.name
        if (routeName === 'adminDashboard') {
          this.populateOwnedCourses()
        }
      },

      populateOwnedCourses () {
        var itemCount
        if ($(window).width() < 1501) {
          itemCount = 2
        } else {
          itemCount = 3
        }
        const pagingOptions = {page: this.page, count: itemCount}
        this.loadOwnedCourses(pagingOptions).then(res => {
          if (res) {
            this.courses = res.content
            this.lastPage = res.lastPage
          }
        })
      },

      beforeDestroy: function () {
        window.removeEventListener('resize', this.handleWindowResize)
      },

      prev () {
        this.page -= 1
        this.populateOwnedCourses()
      },

      next () {
        this.page += 1
        this.populateOwnedCourses()
      },

      navigateToCourseDashboard (uuid) {
        this.$store.commit('LOAD_COURSE', {})
        this.$store.commit('LOAD_CLASS_SUMMARY', {})
        this.$store.commit('LOAD_COURSE_TOPICS', {})
        this.$store.commit('LOAD_COURSE_LINEAR_TOPICS', {})
        return this.$router.push({name: 'courseDashboardInstructor', params: { uuid: uuid }})
      }
    },

    computed: {
      ...mapState({
        'userObj': state => state.user.userObj,
        'links': state => state.dashboard.quickLinks,
        'institution': state => state.institution.institution
      }),
      dashboardReports () {
        if (this.userReports.length > 0) {
          let dashboardReports = []
          this.userReports.forEach((item, i) => {
            if (item.showOnDashboard) {
              dashboardReports.push(item)
            }
          })
          return dashboardReports
        } else {
          return []
        }
      }
    }
  }
</script>

<style scoped>
    .next {
        margin-top: 10%;
    }

    .icon-master {
        float: right !important;
        margin-top: 0px !important;
        margin-left: 0px !important;
    }

    .slide-leave-active, .slide-enter-active {
        transition: 1s;
    }

    .slide-enter {
        transform: translate(100%, 0);
    }

    .slide-leave-to {
        transform: translate(-100%, 0);
    }

    .img-slider {
        overflow: hidden;
        position: relative;
        height: 200px;
        width: 400px;
    }
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/AdminDashboard.vue